// Generated by ReScript, PLEASE EDIT WITH CARE


function decode(slug, name) {
  switch (slug) {
    case "BOT" :
      return "Bot";
    case "ERP" :
      return "ERP";
    case "W" :
      return "AppWinoFr";
    case "d" :
      return "DashboardWinoFr";
    case "winopay" :
      return "WinoPay";
    default:
      return {
        TAG: "CashRegister",
        slug: slug,
        name: name
      };
  }
}

function format(name) {
  if (typeof name === "object") {
    return name.slug + ` - ` + name.name;
  }
  switch (name) {
    case "DashboardWinoFr" :
      return "dashboard.wino.fr";
    case "AppWinoFr" :
      return "app.wino.fr";
    case "ERP" :
      return "ERP";
    case "Bot" :
      return "BOT";
    case "WinoPay" :
      return "WinoPay";
  }
}

export {
  decode,
  format,
}
/* No side effect */
